var _circle, _circle2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBee(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 36,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6901 29L24.4239 34.5582C23.8747 35.4927 23.8581 36.6571 24.3802 37.6087L26.1798 40.8848C27.0722 42.5091 27.0722 44.4909 26.1798 46.1152L24.3802 49.3913C23.8581 50.3429 23.8747 51.5073 24.4239 52.4418L27.6901 58L34.4305 45.7299C35.1898 44.3462 35.1898 42.656 34.4305 41.2723L27.6901 29Z",
    fill: "#544A99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0402 28.4265C40.1862 26.9268 38.579 26 36.8372 26H32.002L40.6003 41.0969C41.4504 42.5888 41.4504 44.4092 40.6003 45.9011L32 61H36.8352C38.5771 61 40.1842 60.0732 41.0383 58.5735L48.4575 45.5472C49.1808 44.2763 49.1808 42.7237 48.4575 41.4528L41.0402 28.4265Z",
    fill: "#68BFA4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0383 28.4265C55.1842 26.9268 53.5771 26 51.8352 26H47L55.5983 41.0969C56.4485 42.5888 56.4485 44.4092 55.5983 45.9011L47 61H51.8352C53.5771 61 55.1842 60.0732 56.0383 58.5735L63.4575 45.5472C64.1808 44.2763 64.1808 42.7237 63.4575 41.4528L56.0383 28.4265Z",
    fill: "#544A99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBee);
export default __webpack_public_path__ + "static/media/iconBee.dd546c6d1694fdb74476ba441a9482a5.svg";
export { ForwardRef as ReactComponent };